// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O69Q1JlJQd4L8YpW{width:100%;margin-top:16px}.jcfqL9bx0Y0KBIhj{height:384px;display:grid;place-items:center}.Ses1oHsyUsg_iylE{width:100%}.Ses1oHsyUsg_iylE tbody{width:100%}.Ses1oHsyUsg_iylE tbody .LnryiFS32HMzOISm{height:40px;width:100%;display:flex;justify-content:space-between}.Ses1oHsyUsg_iylE tbody .LnryiFS32HMzOISm .nLBESepstcK9bLmF{min-width:184px;display:flex;justify-content:flex-start;align-items:center;padding-left:8px}.Ses1oHsyUsg_iylE tbody .LnryiFS32HMzOISm .dSkxGIqQaEoAi4Nh{display:flex;padding:0 8px;justify-content:center;align-items:center}.Ses1oHsyUsg_iylE tbody .LnryiFS32HMzOISm ._YqvkliEiIgPyopG{display:flex;margin-left:auto;justify-content:flex-end;align-items:center;width:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `O69Q1JlJQd4L8YpW`,
	"emptyContainer": `jcfqL9bx0Y0KBIhj`,
	"table": `Ses1oHsyUsg_iylE`,
	"row": `LnryiFS32HMzOISm`,
	"cohortColumn": `nLBESepstcK9bLmF`,
	"percentageBarColumn": `dSkxGIqQaEoAi4Nh`,
	"enpsScoreColumn": `_YqvkliEiIgPyopG`
};
export default ___CSS_LOADER_EXPORT___;
